import { closeModal as closeModalAction, openModal as openModalAction } from 'store/modals/actions';
import { selectModalProps } from 'store/modals/selectors';
import { ModalName, ModalPropsType } from 'store/modals/types';

import { useDispatch, useSelector } from 'hooks';

import { setCancellationCandidate } from '../../store/subscriptions/actions';

export const useModals = () => {
    const dispatch = useDispatch();
    const modalProps = useSelector(selectModalProps);

    const openModal = <T extends ModalName>(modalId: T, props?: ModalPropsType[T]) => {
        dispatch(openModalAction(modalId, props));
    };

    const closeModal = () => {
        dispatch(setCancellationCandidate(null));
        dispatch(closeModalAction());
    };

    return { openModal, closeModal, modalProps };
};
